// XXX obsolete, preserved for backwards compatibility with old jobs
/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import {Facet} from "../facets/facet"
import {GMAP_REFERENCE_FRAME} from "../frames/gmap-reference"
import { multisort, desc, valueToDate } from "../../core/utils/property-sort"

export const GMAP_REFERENCE_FACET = new Facet({
    frame: GMAP_REFERENCE_FRAME,
    multiSelect: true,
    defaultColumns: [
        "id", "name", "organism", "ploidy", "totalLength", "numRecords",
        "createdAt", "updatedAt"],
    initialSort: multisort(desc(valueToDate("updatedAt")), desc(valueToDate("createdAt"))),
    additionalColumns: [
        "uuid", "path",
        "tags", "projectId", "version", "md5", "createdBy", "comments"],
    displayProperties: [
        "name", "organism", "ploidy", "totalLength", "numRecords",
        "createdAt", "updatedAt", "id", "uuid", "path",
        "tags", "projectId", "version", "md5", "createdBy", "comments"]
})
